(() => {
  if (window.__tmp2Plus1PdpLayoutReady) return;
  window.__tmp2Plus1PdpLayoutReady = true;

  let scheduled = false;

  const sync = () => {
    scheduled = false;

    document.querySelectorAll('#MainContent .tmp-pdp-trust').forEach((node) => node.remove());

    const root = document.querySelector('#MainContent .tmp-meller-offer');
    if (!root) return;

    const info = root.closest('.product__info-container') ||
      document.querySelector('#MainContent .product__info-container');
    if (!info) return;

    const titlePriceRow = info.querySelector('.tmp-standard-title-price-row');
    const priceBlock = info.querySelector('.product__block--price');
    const titleBlock = info.querySelector('.product__block--title');
    const anchor = titlePriceRow || priceBlock || titleBlock;

    if (anchor && anchor.nextElementSibling !== root) {
      anchor.after(root);
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(sync);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:block:select', schedule);
  document.addEventListener('variant:changed', schedule);

  const observeRoot = document.getElementById('MainContent') || document.documentElement;
  new MutationObserver(schedule).observe(observeRoot, { childList: true, subtree: true });
})();
